import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { fetchMe } from './api';

type Role = 'user' | 'design' | 'admin';

interface RoleContextValue {
  role: Role | null;
  loading: boolean;
}

const RoleContext = createContext<RoleContextValue>({ role: null, loading: true });

export function RoleProvider({ children }: { children: ReactNode }) {
  const [role, setRole] = useState<Role | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchMe()
      .then((me) => {
        if (!cancelled) {
          setRole(me.role);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setRole('user');
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <RoleContext.Provider value={{ role, loading }}>{children}</RoleContext.Provider>;
}

export function useRole(): RoleContextValue {
  return useContext(RoleContext);
}

export function hasMinRole(role: Role | null, minimum: 'design' | 'admin'): boolean {
  if (!role) return false;
  if (minimum === 'admin') return role === 'admin';
  return role === 'design' || role === 'admin';
}
